<template>
  <Layout class="layout-content">
    <div class="m-wrap-edit">
      <affix target="ivu-layout" :offset-top="64" :z-index="899">
        <div class="m-header-edit">
          <span class="item-field task-h2">任务编号</span>
          <span
            v-for="(task, i) in taskIds"
            :key="task"
            class="m-creative-btn"
            :class="{ 'm-current': i === current }"
            @click="handleClickTask(i)"
          >
            <span>{{ task }}</span>
            <span>&ensp;</span>
            <em @click.stop="onTaskDuplicate(i)" v-if="copyState" class="el-icon-copy-document"></em>
            <template v-if="taskData[i]">
              <Icon
                v-if="taskIds.length > 1"
                type="md-remove-circle"
                color="#ed4014"
                size="16"
                @click="showConfirmBox($event, i)"
                style="left: -6px; width: 10px"
              />
              <Icon v-if="taskData[i]._xhr" type="md-checkmark-circle" color="#19be6b" size="16" />
              <Icon v-else type="md-time" color="#ff8000" size="16" />
            </template>
          </span>
          <!-- <span class="item-copy">
            <div v-if="copyState">
              <el-button type="primary" @click="onTaskDuplicate">复制任务</el-button>
            </div>
          </span> -->
        </div>
      </affix>

      <div class="module-content" ref="container">
        <moduler title="基础信息" name="basic">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放账号</span>
            </Col>
            <Col span="12">
              <!--  使用原项目不能修改账号 -->
              <auto-complete
                v-if="copyState && isCreateNewItem"
                :data="accountData"
                v-model="formItem.account"
                placeholder="请选择投放账号"
                :width="480"
                :clearable="false"
                @on-select="handleAccount"
              />
              <!-- 使用原项目 -->
              <Input v-else v-model="formItem.ad_account_name" disabled style="width: 480px" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">创建方式</span>
            </Col>
            <Col span="12" v-if="copyPage">
              <RadioGroup v-model="formItem.createType" type="button">
                <Radio label="new">新建项目</Radio>
                <Radio label="inherit">使用原项目</Radio>
              </RadioGroup>
            </Col>

            <Col span="12" v-else>
              <RadioGroup v-model="formItem.createType" type="button">
                <Radio :disabled="formItem.createType === 'inherit'" label="new">新建项目</Radio>
                <Radio :disabled="formItem.createType === 'new'" label="inherit">使用原项目</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.createType === 'inherit'">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">项目名称</span>
            </Col>
            <Col span="12">
              <el-input style="width: 480px" :value="formItem.project_name" disabled></el-input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">计划名称</span>
            </Col>
            <Col span="18">
              <input-len
                v-model="formItem.plan_name"
                placeholder="最大90个字符，1个中文等于2个字符"
                :disabled="!copyState"
                :width="480"
                :max="90"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放游戏</span>
            </Col>
            <Col span="12">
              <auto-complete :data="platformGameData" v-model="formItem.game_id" disabled placeholder="请选择推广游戏"></auto-complete>
            </Col>
          </Row>
          <!-- <Row class="row-item" :gutter="12" v-if="formItem.ch_platform_id === 1">
            <Col span="3" class="col-item">
              <span class="item-field">头条分包</span>
            </Col>
            <Col span="12" class="col-flex">
              <switch-plus v-model="formItem.media_pack_switch" :true-value="1" :false-value="0" disabled />
            </Col>
          </Row> -->
          <Row class="row-item" :gutter="12" v-if="isCreateNewItem">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">优化目标名称</span>
            </Col>
            <Col span="12">
              <Select v-model="formItem.convertId" style="width: 360px" placeholder="请选择优化目标" :disabled="!planState">
                <Option v-for="item in convertData" :value="item.key" :key="item.key">{{ item.value }}</Option>
              </Select>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-else>
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">优化目标名称</span>
            </Col>
            <Col span="12">
              <!-- 使用原项目禁用优化目标 -->
              <Select :value="taskRawData[current].formItem.convertId" style="width: 360px" placeholder="请选择优化目标" disabled>
                <Option v-for="item in convertData" :value="item.key" :key="item.key">{{ item.value }}</Option>
              </Select>
            </Col>
          </Row>
        </moduler>

        <moduler v-show="isCreateNewItem" title="营销目标及场景" name="purpose_scene">
          <div :class="{ 'disable-out-plan': !planState }">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广目的</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.landing_type" type="button">
                  <Radio label="APP" disabled>应用推广</Radio>
                  <Radio label="MICRO_GAME" disabled>小程序投放</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'MICRO_GAME'">
              <Col span="3" class="col-item">
                <span class="item-field">投放内容</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.micro_promotion_type" type="button">
                  <Radio disabled label="WECHAT_GAME">微信小游戏</Radio>
                  <Radio disabled label="BYTE_GAME">字节小游戏</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'APP'">
              <Col span="3" class="col-item">
                <span class="item-field">子目的</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.app_promotion_type" type="button">
                  <Radio label="DOWNLOAD" disabled>应用下载</Radio>
                  <Radio label="LAUNCH" disabled>应用调起</Radio>
                  <Radio label="RESERVE" disabled>预约下载</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'MICRO_GAME'">
              <Col span="3" class="col-item">
                <span class="item-field">小游戏资产ID</span>
              </Col>
              <Col span="12">
                <el-input style="width: 320px" v-model="formItem.micro_app_instance_id" disabled></el-input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">关联星广联投任务</span>
              </Col>
              <Col span="12" v-if="taskData[current]">
                <el-select
                  v-model="formItem.star_task"
                  value-key="star_task_id"
                  filterable
                  clearable
                  :disabled="!copyState"
                  placeholder="请选择"
                  style="width: 320px"
                  @change="onStarTaskChange"
                >
                  <el-option
                    v-for="starTask in taskData[current].starTaskList"
                    :key="starTask.star_task_id"
                    :label="starTask.star_task_name"
                    :value="starTask"
                  ></el-option>
                </el-select>
                <!-- 关联星广联投任务选择了任意一个才显示自动优选素菜开关 -->
                <div v-if="isStarTask" class="star-auto-material-switch">
                  <el-switch disabled v-model="formItem.star_auto_material_addition_switch" active-value="ON" inactive-value="OFF">
                  </el-switch>
                  <p>自动优选素材：开启后系统会替换/暂停/删除本项目下计划素材</p>
                </div>
              </Col>
            </Row>

            <!-- ios 应用下载时显示子链接 -->
            <Row class="row-item" :gutter="12" v-if="formItem.app_promotion_type === 'DOWNLOAD' && formItem.ch_platform_id === 2">
              <Col span="3" class="col-item">
                <span class="item-field">应用链接</span>
              </Col>
              <Col span="12">
                <el-input v-model="formItem.download_url" placeholder="请输入应用链接"></el-input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.app_promotion_type === 'RESERVE'">
              <Col span="3" class="col-item">
                <span class="item-field">预约链接</span>
              </Col>
              <Col span="12">
                <el-input v-model="formItem.subscribe_url" placeholder="请输入预约链接"></el-input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">营销场景</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.marketing_goal" type="button">
                  <Radio label="VIDEO_AND_IMAGE">短视频+图文</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">计划类型</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.ad_type" type="button">
                  <Radio label="ALL">所有计划</Radio>
                  <Radio label="SEARCH">搜索计划</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.ad_type === 'ALL'">
              <Col span="3" class="col-item">
                <span class="item-field">投放模式</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_mode" type="button" @on-change="changeDeliveryMode">
                  <Radio label="MANUAL">手动投放</Radio>
                  <Radio label="PROCEDURAL" :disabled="formItem.app_promotion_type === 'RESERVE'">自动投放（UBMax）</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.ad_type === 'SEARCH'">
              <Col span="3" class="col-item">
                <span class="item-field">投放模式</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_type" type="button">
                  <!-- <Radio label="NORMAL">常规投放</Radio> -->
                  <Radio label="DURATION">极速智投</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <template v-if="formItem.ad_type === 'SEARCH' && formItem.delivery_type === 'NORMAL'">
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">蓝海流量投放</span>
                </Col>
                <Col span="12">
                  <RadioGroup v-model="formItem.blue_flow_package.blue_flow_package_setting" type="button">
                    <Radio label="OFF">不启用</Radio>
                    <Radio label="ON">启用</Radio>
                  </RadioGroup>
                  <div style="margin-top: 5px" v-if="formItem.blue_flow_package.blue_flow_package_setting === 'ON'">
                    <BlueFlowPackageTable
                      v-model="formItem.blue_flow_package.blue_flow_package_id"
                      :account-id="formItem.account"
                      @change="onBlueFlowPackageChange"
                    ></BlueFlowPackageTable>
                  </div>
                </Col>
              </Row>
            </template>
          </div>
        </moduler>

        <moduler title="搜索快投" name="search_bid" v-if="formItem.ad_type === 'ALL' && formItem.delivery_mode === 'MANUAL'">
          <!-- 自动投放/小程序链路/投放范围仅穿山甲时不支持快投
          https://open.oceanengine.com/labels/7/docs/1740868093375503
           -->
          <div :class="{ 'disable-out-plan': !planState }">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">开启</span>
              </Col>
              <Col span="12">
                <i-Switch style="position: relative; top: 3px" v-model="formItem.keywordSwitch" :true-value="1" :false-value="0" />
              </Col>
            </Row>

            <template v-if="formItem.keywordSwitch">
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">关键词</span>
                </Col>
                <Col span="12">
                  <el-input style="width: 280px" :value="searchBidTips" readonly placeholder="未添加关键词，待自动更新"></el-input>
                  <el-button type="text" @click="onSearchKeywordAdd">编辑</el-button>
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">出价系数</span>
                </Col>
                <Col span="12">
                  <el-input
                    style="width: 280px"
                    v-model="formItem.search_bid_ratio"
                    placeholder="请输入1.00-2.00之间的值，最多2位小数"
                  ></el-input>
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">定向扩展</span>
                </Col>
                <Col span="12" class="ghost-button-styles">
                  <el-radio-group v-model="formItem.audience_extend">
                    <el-radio-button ghost label="ON">开启</el-radio-button>
                    <el-radio-button ghost label="OFF">不开启</el-radio-button>
                  </el-radio-group>
                </Col>
              </Row>
            </template>
          </div>
        </moduler>
        <moduler v-show="isCreateNewItem" title="版位及定向" name="target">
          <div :class="{ 'disable-out-plan': !planState }" style="margin-left: 94px">
            <ToutiaoTargetingForm
              :is-procedural="formItem.delivery_mode === 'PROCEDURAL'"
              ad-marketing-scene-disabled
              ref="toutiaoTargetingFormRef"
            >
            </ToutiaoTargetingForm>
          </div>
        </moduler>

        <moduler v-show="isCreateNewItem" title="项目排期及预算" name="schedule_budget">
          <div :class="{ 'disable-out-plan': !planState }">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">投放时间</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.schedule_type" type="button">
                  <Radio label="SCHEDULE_FROM_NOW" :disabled="disableTotal">从今天起长期投放</Radio>
                  <Radio label="SCHEDULE_START_END">设置开始和结束日期</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row v-if="formItem.delivery_setting.schedule_type === 'SCHEDULE_START_END'" class="row-item" :gutter="12">
              <Col span="3">&nbsp;</Col>
              <Col span="12">
                <DatePicker
                  type="daterange"
                  :value="formItem.datetime"
                  :options="datetimeOption"
                  @on-change="changeDatetime"
                  placeholder="请选择投放时间"
                  style="width: 267px"
                ></DatePicker>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">投放时段</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.timeRange" type="button" @on-change="clearWeektime">
                  <Radio label="NONE">不限</Radio>
                  <Radio label="RANGE">指定时间段</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row v-if="formItem.timeRange === 'RANGE'" class="row-item" :gutter="12">
              <Col span="3">&nbsp;</Col>
              <Col span="12">
                <drag-weektime v-model="mult_timeRange" :data="formItem.weektimeData" @on-clear="clearWeektime"></drag-weektime>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">竞价策略</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.bid_type" type="button" @on-change="changeBidType">
                  <Radio label="CUSTOM">稳定成本</Radio>
                  <Radio label="UPPER_CONTROL" :disabled="formItem.delivery_mode === 'PROCEDURAL' || isSearch">控制成本上限 </Radio>
                  <Radio label="NO_BID" :disabled="isDuration">最大转化</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.bid_type === 'CUSTOM'">
              <Col span="3" class="col-item">
                <span class="item-field">计划潜力探索</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.bid_type_upgrade" @on-change="onExploreUpgradeChange" type="button">
                  <Radio label="CUSTOM">常规版</Radio>
                  <Radio label="EXPLORE_UPGRADE">升级版</Radio>
                </RadioGroup>
                <p style="margin-top: 6px; color: red">注意：计划潜力探索-升级版为【白名单功能】，未开通请勿选择</p>
              </Col>
            </Row>

            <!-- 只有稳定成本的竞价策略时，显示投放速度 -->
            <!-- <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.bid_type === 'CUSTOM'">
              <Col span="3" class="col-item">
                <span class="item-field">投放速度</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.bid_speed" type="button">
                  <Radio label="FAST">加速</Radio>
                  <Radio label="BALANCE">匀速</Radio>
                </RadioGroup>
              </Col>
            </Row> -->

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">项目预算</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.budget_mode" type="button">
                  <Radio label="BUDGET_MODE_INFINITE" :disabled="formItem.delivery_mode === 'PROCEDURAL'">不限</Radio>
                  <Radio label="BUDGET_MODE_DAY">设置预算</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <!-- 只有最大转化的竞价策略且设置预算时，显示预算择优分配 -->
            <Row
              class="row-item"
              :gutter="12"
              v-if="formItem.delivery_setting.bid_type === 'NO_BID' && formItem.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'"
            >
              <Col span="3" class="col-item">
                <span class="item-field">预算择优分配(CBO)</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.budget_optimize_switch" type="button">
                  <Radio label="OFF" :disabled="formItem.delivery_mode === 'PROCEDURAL'">不启用</Radio>
                  <Radio label="ON">启用</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">日预算</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  :max="7"
                  :min="300"
                  :step="0.1"
                  :maxNum="10000000"
                  :precision="2"
                  v-model="formItem.delivery_setting.budget"
                  placeholder="预算不少于300元，不超过10000000元"
                  :width="267"
                />
                <span style="margin-left: 10px">元</span>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="projectBidVisible">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">目标出价</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  :max="5"
                  :min="0.1"
                  :step="0.1"
                  :maxNum="10000"
                  :precision="2"
                  v-model="formItem.delivery_setting.cpa_bid"
                  placeholder="不少于0.1元，不超过10000元"
                  :width="267"
                />
                <span style="margin-left: 10px">元</span>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度优化方式</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.delivery_setting.deep_bid_type" type="button">
                  <Radio label="">无深度优化</Radio>
                  <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="DEEP_BID_MIN"
                    >自定义双出价</Radio
                  >
                  <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="ROI_COEFFICIENT"
                    >ROI系数</Radio
                  >
                  <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="BID_PER_ACTION"
                    >每次付费</Radio
                  >
                  <Radio
                    :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'"
                    label="FIRST_AND_SEVEN_PAY_ROI"
                    >首日ROI+7日ROI</Radio
                  >
                  <Radio
                    :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'"
                    label="PER_AND_SEVEN_PAY_ROI"
                    >每次付费+7日ROI</Radio
                  >
                </RadioGroup>
              </Col>
            </Row>
            <template v-if="formItem.delivery_mode === 'PROCEDURAL' && formItem.delivery_setting.bid_type !== 'NO_BID'">
              <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.deep_bid_type === 'DEEP_BID_MIN'">
                <Col span="3" class="col-item">
                  <span class="item-field row-item-must">深度目标出价</span>
                </Col>
                <Col span="12">
                  <input-number-plus
                    :max="5"
                    :min="0.1"
                    :step="0.1"
                    :maxNum="10000"
                    :precision="2"
                    v-model="formItem.delivery_setting.deep_cpabid"
                    placeholder="不少于0.1元，不超过10000元"
                    :width="267"
                  />
                </Col>
              </Row>
              <Row
                class="row-item"
                :gutter="12"
                v-if="
                  ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(formItem.delivery_setting.deep_bid_type)
                "
              >
                <Col span="3" class="col-item">
                  <span class="item-field row-item-must">ROI系数</span>
                </Col>
                <Col span="12">
                  <input-number-plus
                    :min="0.1"
                    :step="0.1"
                    :maxNum="5"
                    :precision="4"
                    v-model="formItem.delivery_setting.roi_goal"
                    placeholder="ROI系数不大于5，保留小数点后四位"
                    :width="267"
                  />
                </Col>
              </Row>
            </template>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">监测链接</span>
              </Col>
              <Col span="12">
                <div class="col-flex" style="height: 32px">
                  <span style="color: #aaa">系统自动生成</span>
                </div>
              </Col>
            </Row>
          </div>
        </moduler>

        <moduler title="计划创意" name="creative">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">创意方式</span>
            </Col>

            <Col span="12">
              <RadioGroup v-model="idea.creative_mode" type="button" @on-change="creativeModeChange">
                <Radio :label="1" :disabled="normalCreativeModeDisabled"> 常规创意 </Radio>
                <Radio :label="2"> 抖音达人视频 </Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">推广身份</span>
            </Col>
            <Col span="12" style="margin-left: -3px">
              <RadioGroup v-model="idea.awemeIdentity" type="button">
                <Radio label="ACCOUNT" v-if="idea.creative_mode === 1">账户信息</Radio>
                <Radio label="AWEME" v-if="idea.creative_mode === 1">抖音号</Radio>
                <Radio label="AWEME_VIDEO" v-if="idea.creative_mode === 2">抖音达人视频</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <template v-if="idea.awemeIdentity === 'AWEME'">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">抖音号</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <el-select
                  v-model="idea.aweme_id"
                  placeholder="请选择推广抖音号"
                  style="width: 420px; margin-bottom: 10px"
                  :loading="loading"
                  :popper-append-to-body="false"
                  filterable
                >
                  <el-option
                    v-for="item in awemeList"
                    :key="item.aweme_id"
                    :label="item.aweme_name"
                    :value="item.aweme_id"
                    style="width: 420px; height: 60px"
                  >
                    <img :src="item.aweme_avatar" width="40" style="float: left; margin-top: 10px; border-radius: 50px" />
                    <div style="display: flex; flex-direction: column; margin-top: 8px">
                      <span style="float: left; margin-left: 8px; color: black; line-height: 25px">{{ item.aweme_name }}</span>
                      <span style="float: left; margin-left: 8px; color: rgb(126 126 126); line-height: 20px; font-size: 10px"
                        >ID: {{ item.aweme_id }}</span
                      >
                    </div>
                  </el-option>
                </el-select>
                <br />
                <Checkbox v-model="idea.is_feed_and_fav_see" true-value="ON" false-value="OFF">主页作品列表隐藏视频</Checkbox>
              </Col>
            </Row>
          </template>

          <template v-if="idea.awemeIdentity === 'AWEME_VIDEO'">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">达人选择</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <!-- 目前只支持提交一个达人，所以切换达人后清空已选视频 -->
                <el-select
                  v-model="idea.aweme_video_user_id"
                  @change="awemeSelect"
                  :popper-append-to-body="false"
                  placeholder="请选择达人"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in idea.uniqueAuthedAwemeList"
                    :key="item.aweme_id"
                    :label="item.aweme_name"
                    :value="item.aweme_id"
                  ></el-option>
                </el-select>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">视频选择</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <div class="aweme-video-list" v-loading="loading">
                  <div
                    v-for="item in filteredAwemeVideoList"
                    :key="item.aweme_id"
                    class="aweme-video-item"
                    :class="idea.selectedAwemeVideos.map((i) => i.video_info.item_id).includes(item.video_info.item_id) ? 'active' : ''"
                    @click="onAwemeVideoSelect(item)"
                  >
                    <em class="check-icon el-icon-circle-check"></em>
                    <el-tag class="preview" @click="onAwemeVideoPreview(item)"> 预览</el-tag>
                    <p class="desc">{{ item.video_info.title }}</p>
                    <el-image
                      class="aweme-video-cover"
                      style="width: 165px"
                      :src="item.video_info.video_cover_url"
                      fit="contain"
                    ></el-image>
                  </div>
                </div>
              </Col>
            </Row>

            <template v-if="isStarTaskAutoMaterialEnable">
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">抖音号</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <el-radio-group disabled v-model="idea.aweme_setting_type">
                    <el-radio-button ghost label="SINGLE"> 指定抖音号 </el-radio-button>
                    <el-radio-button ghost label="ALL"> 全部抖音号 </el-radio-button>
                  </el-radio-group>
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">标题</span>
                </Col>
                <Col span="12" style="margin-left: -3px">
                  <el-radio-group disabled v-model="idea.original_video_title">
                    <el-radio-button ghost label="OFF"> 手动添加 </el-radio-button>
                    <el-radio-button ghost label="ON"> 投放原视频标题 </el-radio-button>
                  </el-radio-group>
                </Col>
              </Row>
            </template>
          </template>

          <template v-if="showFormFields.anchor_related_type && ['AWEME_VIDEO', 'AWEME'].includes(idea.awemeIdentity)">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">原生锚点</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <RadioGroup v-model="idea.anchor_related_type" type="button">
                  <Radio label="OFF">不启用</Radio>
                  <Radio label="AUTO">自动生成</Radio>
                  <Radio label="SELECT">手动生成</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="idea.anchor_related_type === 'SELECT'">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">选择锚点</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <AnchorSelect
                  v-model="idea.anchor_id"
                  :anchor-name.sync="idea.anchor_name"
                  :account="formItem.account"
                  :package-android="formItem.ch_platform_id === 1 ? formItem.package : null"
                  :package-ios="formItem.ch_platform_id === 2 ? formItem.package : null"
                ></AnchorSelect>
              </Col>
            </Row>
          </template>

          <template v-if="idea.creative_mode == 1">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">创意素材</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="idea.image_mode" type="button">
                  <Radio label="CREATIVE_IMAGE_MODE_VIDEO"
                    >视频 {{ idea.videoCreative && idea.videoCreative.length ? `(${idea.videoCreative.length})` : '' }}</Radio
                  >
                  <Radio label="CREATIVE_IMAGE_MODE_CAROUSEL">
                    图文{{
                      idea.carousel_material_list && idea.carousel_material_list.length ? `(${idea.carousel_material_list.length})` : ''
                    }}
                  </Radio>

                  <Radio label="CREATIVE_IMAGE_MODE_SMALL" v-if="!isDouyin"
                    >小图 {{ idea.imageCreative && idea.imageCreative.length ? `(${idea.imageCreative.length})` : '' }}</Radio
                  >
                  <Radio label="CREATIVE_IMAGE_MODE_LARGE" v-if="!isDouyin"
                    >大图 {{ idea.largeCreative && idea.largeCreative.length ? `(${idea.largeCreative.length})` : '' }}</Radio
                  >
                  <!-- <Radio label="CREATIVE_IMAGE_MODE_GROUP">组图 {{(idea.groupCreative && idea.groupCreative.length) ? `(${idea.groupCreative.length})` : ''}}</Radio> -->
                </RadioGroup>
              </Col>
            </Row>

            <Row v-if="idea.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO'" class="row-item" :gutter="12">
              <Col span="3" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('video')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="video"
                  :data="idea.videoCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>

            <Row v-if="idea.image_mode === 'CREATIVE_IMAGE_MODE_CAROUSEL'" class="row-item" :gutter="12">
              <Col span="3" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="showCarouselSelectModal(0)"></Button>
              </Col>
              <Col span="18">
                <div class="carousel-list">
                  <CarouselItem
                    @click="carouselModal = true"
                    v-for="(carousel, index) in carouselList"
                    :key="carousel.id + '' + index"
                    :value="carousel"
                  >
                    <template v-slot:changebtn>
                      <el-button type="text" @click="showCarouselSelectModal(1, index)">修改</el-button>
                      <el-button type="text" @click="onCarouselItemRemove(index)">删除</el-button>
                    </template>
                  </CarouselItem>
                </div>
              </Col>
            </Row>

            <Row v-if="idea.image_mode === 'CREATIVE_IMAGE_MODE_SMALL'" class="row-item" :gutter="12">
              <Col span="3" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('image')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="image"
                  :data="idea.imageCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="idea.image_mode === 'CREATIVE_IMAGE_MODE_LARGE'" class="row-item" :gutter="12">
              <Col span="3" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('large')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="large"
                  :data="idea.largeCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="idea.image_mode === 'CREATIVE_IMAGE_MODE_GROUP'" class="row-item" :gutter="12">
              <Col span="3" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('group')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="group"
                  :data="idea.groupCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12" v-if="showFormFields.text_abstract">
            <Col span="3" class="col-item">
              <span class="item-field">文本摘要</span>
            </Col>
            <Col span="12">
              <el-input
                v-if="idea.text_abstract_list.length < 10"
                v-model="idea.text_abstract"
                placeholder="单计划最多10个，长度25-45个字，两个英文字符占1位，空格分隔，回车添加，非必填"
                @keyup.enter.native="onTextAbstractEnterKeyConfirm"
              >
                <template slot="append">
                  <el-button @click="onTextAbstractEnterKeyConfirm" type="text">&ensp;添加（回车键）</el-button>
                </template>
              </el-input>
              <TextItemsPreview v-show="idea.text_abstract_list.length" :items.sync="idea.text_abstract_list"></TextItemsPreview>
            </Col>
          </Row>

          <!-- <Row class="row-item" :gutter="12" v-if="showFormFields.keywords">
            <Col span="3" class="col-item">
              <span class="item-field">关键词</span>
            </Col>
            <Col span="12" v-if="taskData[current]">
              <template v-if="isBlueFlowEnable">
                <el-select v-model="idea.blue_flow_keywords" filterable placeholder="请选择蓝海流量关键词" style="width: 100%">
                  <el-option
                    v-for="(keyword, index) in blueFlowPackageKeywords"
                    :key="index"
                    :label="keyword.blue_flow_keyword_name"
                    :value="keyword.blue_flow_keyword_name"
                  >
                  </el-option>
                </el-select>
              </template>

              <template v-else>
                <el-input style="width: 280px" :value="planSearchTips" readonly placeholder="未添加关键词"></el-input>
                <el-button type="text" @click="onPlanSearchKeywordAdd">添加关键词</el-button>
              </template>
            </Col>
          </Row> -->

          <Row v-if="statiAssemble && !isStarTaskAutoMaterialEnable" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">创意标题</span>
            </Col>
            <Col span="12">
              <div>
                <Button icon="md-add" @click="addTitleList" :disabled="titleLen === 10">创意标题</Button>
                <span style="padding: 0 8px">已选：{{ titleLen }}/10</span>
                <Button type="primary" @click="docModel = true" :disabled="titleLen === 10" style="margin-left: 20px">选择文案</Button>
              </div>
            </Col>
          </Row>
          <Row v-if="statiAssemble" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <m-caption
                v-for="(item, idx) in idea.title_list"
                :key="idx"
                :index="idx"
                :max-len="60"
                v-model="item.title"
                :words="wordIds"
                :del="titleLen > 1"
                @on-trend="appendTrend"
                @on-clear="deleteTrend"
                @on-delete="delTitleList"
                @on-del-trend="delTrend"
              ></m-caption>
              <span style="color: #ff4400; margin-top: 6px; display: none"
                >注意：添加了动态词，再清除动态词，一定要使用【清除动态词】按钮，否则系统会报错</span
              >
            </Col>
          </Row>
          <template>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">应用名</span>
              </Col>
              <Col span="12"><Input v-model="idea.app_name" placeholder="4-20个字符,中文占两个字符"></Input></Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">来源</span>
              </Col>
              <Col span="12"><Input v-model="idea.source" placeholder="4-20个字符,中文占两个字符"></Input></Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">产品LOGO</span>
              </Col>
              <Col span="12">
                <cardptom-icon v-model="idea.image_ids" :sources="idea.creatives_detail" @on-select="selectLogo" />
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">产品卖点</span>
              </Col>
              <Col span="12" style="margin-left: -3px">
                <add-tags
                  v-model="idea.selling_points"
                  :open-id="opId"
                  :is-show-select="false"
                  :max-tag-num="10"
                  :min-len="12"
                  :max-len="18"
                  @on-close="closeTag($event, 'selling_points')"
                ></add-tags>
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12" v-if="showLdy">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">落地页</span>
            </Col>
            <Col span="12">
              <Button icon="md-add" @click="addLandingPage" :disabled="idea.web_url_material_list.length >= 10">添加落地页</Button>
              <span style="margin-left: 40px">{{ idea.web_url_material_list.length }} / 10</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" style="margin: -10px 0 20px 0" v-if="showLdy">
            <Col span="3" class="col-item"> </Col>
            <Col span="12">
              <div v-for="(item, index) in idea.web_url_material_list" :key="index" style="margin-bottom: 20px">
                <Input v-model="idea.web_url_material_list[index]" style="width: 500px" placeholder="请输入落地页链接" />

                <el-button type="primary" style="margin-left: 10px" @click="showLandingPage(index)">+选择落地页</el-button>

                <Icon
                  type="ios-trash-outline"
                  size="22"
                  color="#ff2200"
                  v-if="idea.web_url_material_list.length > 1"
                  style="cursor: pointer; margin-left: 10px"
                  @click="deleteLandingPage(index)"
                />
              </div>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="showFormFields.action_buttons">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">行动号召文案</span>
            </Col>
            <Col span="12" style="margin-left: -3px">
              <add-tags
                v-model="idea.call_to_action_buttons"
                :open-id="opId"
                :is-show-select="false"
                :max-tag-num="10"
                :min-len="4"
                :max-len="12"
                @on-close="closeTag($event, 'call_to_action_buttons')"
              ></add-tags>

              <div style="margin-top: 10px">
                <el-switch v-model="idea.intelligent_generation" active-value="ON" inactive-value="OFF"></el-switch>
                <span class="tips">&ensp;开启智能生成行动号召</span>
              </div>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="taskData[current] && showFormFields.brand_category">
            <Col span="3" class="col-item">
              <span class="item-field">计划类别</span>
            </Col>
            <Col span="12">
              <el-cascader
                v-model="idea.brand_info.yuntu_category_id"
                filterable
                placeholder="请选择"
                style="width: 100%"
                :options="taskData[current].brandCategory"
                :props="{ checkStrictly: true, value: 'id', label: 'lable' }"
                clearable
              ></el-cascader>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="taskData[current] && showFormFields.brand_info">
            <Col span="3" class="col-item">
              <span class="item-field">品牌名称</span>
            </Col>
            <Col span="12">
              <el-select v-model="idea.brand_info.cdp_brand_id" filterable clearable placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="brand in taskData[current].brandInfo"
                  :key="brand.cdp_brand_id"
                  :label="brand.cdp_brand_name"
                  :value="brand.cdp_brand_id"
                >
                </el-option>
              </el-select>
            </Col>
          </Row>

          <Row class="row-item ghost-button-styles" :gutter="12" v-if="showFormFields.dynamic_creative">
            <Col span="3" class="col-item">
              <span class="item-field">动态创意</span>
            </Col>
            <Col span="12">
              <el-radio-group v-model="idea.dynamic_creative_switch">
                <el-radio-button ghost label="OFF">不开启</el-radio-button>
                <el-radio-button ghost label="ON">开启</el-radio-button>
              </el-radio-group>

              <template v-if="idea.dynamic_creative_switch === 'ON'">
                <el-checkbox-group v-model="idea.advanced_dc_settings">
                  <el-checkbox label="OPTIMIZE_SEARCH_RESULTS_PAGE">优化视频、图片、标题等搜索结果页内容</el-checkbox>
                  <el-checkbox label="OPTIMIZE_LANDING_PAGE">优化落地页</el-checkbox>
                </el-checkbox-group>
              </template>
            </Col>
          </Row>
          <!-- 蓝海流量投放、极速智投必须开启智能拓流，禁止关闭-->
          <!-- <Row class="row-item ghost-button-styles" :gutter="12" v-if="showFormFields.auto_extend_traffic">
            <Col span="3" class="col-item">
              <span class="item-field">智能拓流</span>
            </Col>
            <Col span="12">
              <el-radio-group v-model="idea.auto_extend_traffic" :disabled="autoExtendTrafficDisabled">
                <el-radio-button ghost label="OFF">不开启</el-radio-button>
                <el-radio-button ghost label="ON">开启</el-radio-button>
              </el-radio-group>
              <p class="tips">启用后利用系统能力自动为您拓展更多相似流量，综合提升计划的跑量能力&转化数</p>
            </Col>
          </Row> -->
        </moduler>

        <moduler title="排期及预算" name="idea_budget">
          <template v-if="isSearch">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">预算</span>
              </Col>
              <!-- 极速智投：同项目预算，无需设置 -->
              <Col span="12" v-if="isDuration">
                <div class="col-flex" style="height: 32px">
                  <span style="color: #aaa">同项目预算</span>
                </div>
              </Col>
              <!-- 常规投放：自行设置预算 -->
              <Col span="12" v-else>
                <Input
                  v-model="idea.budget"
                  @on-blur="inputTrim('budget', idea.budget, idea, true)"
                  placeholder="预算不少于300元，不超过9999999.99元"
                  style="width: 267px"
                >
                  <span slot="append">元</span>
                </Input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">目标出价</span>
              </Col>
              <Col span="12">
                <div class="col-flex" style="height: 32px">
                  <span style="color: #aaa">同项目出价（{{ formItem.delivery_setting.cpa_bid }}）</span>
                </div>
              </Col>
            </Row>
          </template>

          <template v-else>
            <template v-if="formItem.delivery_mode === 'MANUAL'">
              <!-- 开启预算择优分配(CBO)时，不显示广告预算，且提交时广告预算传0 -->
              <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.budget_optimize_switch !== 'ON'">
                <Col span="3" class="col-item">
                  <span class="item-field row-item-must">预算</span>
                </Col>
                <Col span="12">
                  <Input
                    v-model="idea.budget"
                    @on-blur="inputTrim('budget', idea.budget, idea, true)"
                    placeholder="预算不少于300元，不超过9999999.99元"
                    style="width: 267px"
                  >
                    <span slot="append">元</span>
                  </Input>
                </Col>
              </Row>

              <template v-if="formItem.delivery_setting.bid_type !== 'NO_BID'">
                <Row class="row-item" :gutter="12">
                  <Col span="3" class="col-item">
                    <span class="item-field row-item-must">出价</span>
                  </Col>
                  <Col span="12">
                    <Input
                      v-model="idea.cpa_bid"
                      @on-blur="inputTrim('cpa_bid', idea.cpa_bid, idea, true)"
                      placeholder="预算不少于0.1元，不超过10000元"
                      style="width: 267px"
                    >
                      <span slot="append">元</span>
                    </Input>
                  </Col>
                </Row>
                <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.deep_bid_type === 'DEEP_BID_MIN'">
                  <Col span="3" class="col-item">
                    <span class="item-field row-item-must">深度目标出价</span>
                  </Col>
                  <Col span="12">
                    <Input
                      v-model="idea.deep_cpabid"
                      @on-blur="inputTrim('deep_cpabid', idea.deep_cpabid, idea, true)"
                      placeholder="请输入0.1~10000的深度优化出价"
                      style="width: 320px"
                    >
                    </Input>
                  </Col>
                </Row>
                <Row
                  class="row-item"
                  :gutter="12"
                  v-if="
                    ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(
                      formItem.delivery_setting.deep_bid_type
                    )
                  "
                >
                  <Col span="3" class="col-item">
                    <span class="item-field row-item-must">ROI系数</span>
                  </Col>
                  <Col span="12">
                    <Input
                      v-model="idea.roi_goal"
                      @on-blur="inputTrimFour('roi_goal', idea.roi_goal, idea, true)"
                      placeholder="请输入ROI系数，ROI系数不大于5，保留小数点后四位"
                      style="width: 320px"
                    >
                    </Input>
                  </Col>
                </Row>
              </template>
            </template>
          </template>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">计划名称</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px">
                <span style="color: #aaa">同项目名称</span>
              </div>
            </Col>
          </Row>
        </moduler>
      </div>
    </div>

    <uploader
      v-model="creativeModel"
      :multiple="creativeMult"
      :media="media"
      :type="creativeType"
      :width="creativeWidth"
      :height="creativeHeight"
      :smart="creativeSmart"
      :default-option="formItem.game_id"
      @on-upload="uploadFileHandler"
      @on-cancel="creativeMult = false"
    ></uploader>

    <document v-model="docModel" :open-id="opId" @on-select="appendDocument" @on-cancel="docModel = false"></document>

    <Modal v-model="confirmBox" title="提示" :z-index="2021" @on-ok="removeTask(curDelTaskIndex)" @on-cancel="confirmBox = false">
      <p>确认删除当前任务？</p>
    </Modal>

    <page-data
      v-model="pageModal"
      :accounts="[{ id: formItem.account, name: formItem.ad_account_name }]"
      @on-select="onPageSelected"
      @on-close="pageModal = false"
    >
    </page-data>

    <!-- 图文素材选择框 -->
    <CarouselSelectModal
      v-model="carouselModal"
      :multiple-limit="carouselMultipleLimit"
      :account="formItem.account"
      @confirm="onCarouselConfirm"
    ></CarouselSelectModal>

    <!-- 项目搜索快投关键词 -->
    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="formItem.account"
      :list="formItem.searchBidKeywordList"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>

    <!-- 广告搜索关键词 -->
    <SearchBidKeywordSelectModal
      v-model="showPlanSearchKeywordModal"
      :account-id="formItem.account"
      :list="formItem.searchPlanKeywordList"
      @confirm="onPlanKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>

    <div class="ad-submit">
      <Row class="ad-submit-moduler">
        <Col :span="12">
          <error-pop v-model="formErr" :data="errRes" :state="Boolean(errRes.length)" @on-close="errRes = []" />
        </Col>
        <Col :span="12" class="ad-submit-control">
          <Button @click="cannel">取消</Button>
          <Button type="primary" :loading="loading" @click="handleSubmit('submit')"> 确认提交 </Button>
        </Col>
      </Row>
    </div>
  </Layout>
</template>
<script>
import { getSession, rmSession, div } from '@/common/js/api'
import { isArray, isEmpty, formatDate, timeout, deepCopy, isNumber, uniqueArray } from '@/common/js/utils'
import { pick, clone } from '@/common/js/just.js'
import defaultMixin from './toutiao2_mixins'
import planMixin from './toutiao2_mixins/plan'
import ideaMixin from './toutiao2_mixins/idea'
import {
  rebuildTargetingForm,
  proceduralTargetings,
  searchAdTargetings,
  getSubmitTargetingParams
} from '@/views/create/bytedance/hooks/utils/index.js'
import { getSplitText } from '@/views/create/bytedance/components/plan/usePlanForm.js'
import { getCaoHuaGames, adAccount } from '@/api/common.model'
import {
  findPlanTaskById,
  updatePlanTaskByIdNew,
  addToutiaoBatchTaskSecond,
  getCarouselsById,
  getStarDeliveryTaskList,
  getBlueFlowPackageList,
  getBrandCategoryInfo
} from '@/api/toutiao.local.model'
import { getCreativeWordIds, iesAccountSearch, getAuthedAwemeList, getAuthedAwemeListByStarDeliveryTaskId } from '@/api/toutiao.model'
import { getAccountById } from '@/api/ptom.data.model.js'
import InputLen from '@/components/input/input-len.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import weektimeData from '@/data/toutiao/weektime_data'
import SearchBidKeywordSelectModal from '@/views/create/toutiaonew_local/components/group/search-bid.vue'
import CarouselItem from '@/views/create/toutiaonew_local/components/batch/carousel-modal/carousel-item.vue'
import CarouselSelectModal from '@/views/create/toutiaonew_local/components/batch/carousel-modal/carousel-select-modal.vue'

import PageData from '@/components/page-select/page-data.vue'
import ToutiaoTargetingForm from '@/views/promote/targeting/components/toutiao/targeting-form.vue'
import BlueFlowPackageTable from '@/views/create/bytedance/components/project/components/blue-flow-package-table.vue'
import TextItemsPreview from '@/views/create/bytedance/components/layout/text-items-preview.vue'
// 保存被复制次数
let taskDupIndex = 1

// 获取创意词包
const myWordIds = [1736, 1727, 4, 1737, 5128, 5127]

const defaultFormItem = {
  // 基础信息
  ad_account_name: '',
  convert_name: '',
  createType: 'new', // 创建方式
  convertId: '',
  targetingName: '', // 定向名称
  plan_name: '', // 广告计划名称
  app_promotion_type: 'DOWNLOAD', // 子目的
  marketing_goal: 'VIDEO_AND_IMAGE', // 营销场景
  delivery_mode: 'MANUAL', // 投放模式
  ad_type: 'ALL', // 所有广告
  ch_platform_id: 1, // 游戏类型
  game_id: '', // 草花投放游戏ID
  agent: 'NOAGENT', // 是否代投
  call_type: '1', // 上报媒体方式
  app_type: 'APP_ANDROID', // 广告应用下载类型
  landing_type: 'APP', // 下载类型
  // 推广目的是小程序时的小程序类型，默认微信小程序
  // https://open.oceanengine.com/labels/7/docs/1740868093375503
  micro_promotion_type: 'WECHAT_GAME',
  download_type: 'DOWNLOAD_URL', // 投放方式
  package: '', // 广告应用下载包名
  callback_switch: 1, // 回调开关

  star_task: {},
  star_auto_material_addition_switch: 'ON',

  // 投放范围和目标
  delivery_range: 'DEFAULT',
  download_url: '', // 广告应用下载链接
  convert: 'AD_CONVERT_TYPE_ACTIVE',

  delivery_type: 'NORMAL',
  blue_flow_package: {
    blue_flow_package_setting: 'OFF',
    blue_flow_package_id: ''
  },

  // 搜索快投
  keywordSwitch: 0,
  search_bid_ratio: '',
  audience_extend: 'ON',
  keywords: [],
  searchBidKeywordList: [],
  searchPlanKeywordList: [],

  // 排期与预算
  delivery_setting: {
    schedule_type: 'SCHEDULE_FROM_NOW',
    schedule_time: '',
    start_time: formatDate(new Date(), 'yyyy-MM-dd'),
    end_time: formatDate(new Date(), 'yyyy-MM-dd'),

    bid_type: 'CUSTOM', // 竞价策略
    bid_type_upgrade: 'CUSTOM',
    // https://open.oceanengine.com/labels/7/docs/1740868093375503
    // 投放速度
    bid_speed: 'FAST',
    // 预算择优分配(CBO)
    budget_optimize_switch: 'OFF',
    budget_mode: 'BUDGET_MODE_INFINITE', // 项目预算
    budget: '', // 日预算
    deep_bid_type: '', // 深度优化方式
    cpa_bid: '',
    deep_cpabid: '',
    roi_goal: ''
  },
  // 预算与出价
  timeRange: 'NONE', // 投放时间段 默认不传此参数
  hide_if_converted: 'AD',
  weektimeData
}

const defaultIdeaParams = {
  campaign_name: '',
  title_list: [
    {
      title: '',
      creative_word_ids: []
    }
  ],
  text_abstract: '',
  text_abstract_list: [],
  image_list: [],

  blue_flow_keywords: '',

  dynamic_creative_switch: 'OFF',
  advanced_dc_settings: ['OPTIMIZE_SEARCH_RESULTS_PAGE', 'OPTIMIZE_LANDING_PAGE'],

  image_mode: 'CREATIVE_IMAGE_MODE_VIDEO', // 创意素材
  mult_categroy: [],
  imageCreative: [],
  largeCreative: [],
  groupCreative: [],
  videoCreative: [],

  // 产品信息
  selling_points: [], // 产品卖点
  image_ids: '',

  call_to_action_buttons: [], // 行动号召文案
  creatives_detail: [],

  app_name: '',
  creative_display_mode: 'CREATIVE_DISPLAY_MODE_CTR', // 创意展现方式
  creative_material_mode: 'STATIC_ASSEMBLE', // 创意类型

  awemeIdentity: 'ACCOUNT',
  anchor_id: '',
  aweme_id: '',
  anchor_related_type: 'OFF',
  anchor_name: '',
  is_feed_and_fav_see: 'ON',
  aweme_setting_type: 'ALL',
  original_video_title: 'ON',

  // 广告预算与出价
  budget: '', // 预算
  cpa_bid: '', // 出价
  deep_cpabid: '', // 深度目标出价
  roi_goal: '', // ROI系数

  web_url_material_list: [], // 落地页
  authedAwemeVideoList: [],
  uniqueAuthedAwemeList: [],
  selectedAwemeVideos: []
}
export default {
  name: 'failIndex',
  components: {
    InputLen,
    InputNumberPlus,
    SearchBidKeywordSelectModal,
    PageData,
    CarouselItem,
    CarouselSelectModal,
    ToutiaoTargetingForm,
    BlueFlowPackageTable,
    TextItemsPreview
  },
  mixins: [defaultMixin, planMixin, ideaMixin],
  computed: {
    copyState() {
      return this.$route.query.t === 'copy'
    },
    account() {
      const task = this.taskData[this.current]
      return task ? task.account : 3232
    },
    accounts() {
      const task = this.taskData[this.current]
      return task ? task.accounts : []
    },
    targetingParams() {
      const task = this.taskData[this.current]
      if (!task) return {}
      return task.targetings.targetingParam
    },
    formItem() {
      const task = this.taskData[this.current]
      return task ? task.formItem : defaultFormItem
    },
    idea() {
      const task = this.taskData[this.current]
      return task ? task.idea : defaultIdeaParams
    },
    planState() {
      const task = this.taskData[this.current]
      return this.copyState || (task && task.task_progress < 5)
    },
    saveTargetingId() {
      const task = this.taskData[this.current]
      return (task && task.targetings && task.targetings.targetingId) || ''
    },
    isCreateNewItem() {
      // 当使用原项目时,不显示营销目标及场景| 定向| 出价
      return this.formItem.createType === 'new'
    },
    isAllowCard() {
      // 1、投放范围不是穿山甲。 2、投放位置包含抖音信息流广告。
      const { inventory, inventory_type, scene_inventory } = this.idea
      const unUnion = this.formItem.delivery_range !== 'UNION'
      const haveFeed = inventory === 'POSITION_MEDIA' && inventory_type.includes('INVENTORY_AWEME_FEED')
      const isPosition = inventory === 'POSITION_AD'
      const isVideoScene = inventory === 'POSITION_SCREEN' && scene_inventory === 'VIDEO_SCENE'
      return (haveFeed || isPosition || isVideoScene) && unUnion
    },
    isDouyin() {
      const task = this.taskData[this.current]
      if (!task?.taskId) return false
      const { inventory_type } = this.taskTargetingParams[task.taskId] || {}
      return inventory_type?.length === 1 && inventory_type.includes('INVENTORY_AWEME_FEED')
    },
    isStarTask() {
      return !!this.formItem.star_task?.star_task_id
    },
    isStarTaskAutoMaterialEnable() {
      return this.isStarTask && this.formItem.star_auto_material_addition_switch === 'ON'
    },
    searchBidTips() {
      const len = this.formItem?.searchBidKeywordList?.length
      if (len) {
        const [firstItem] = this.formItem.searchBidKeywordList
        return `已选${firstItem.keyword}...共${len}个关键词`
      }
      return '未添加关键词，待自动更新'
    },
    planSearchTips() {
      const len = this.formItem?.searchPlanKeywordList?.length
      if (len) {
        const [firstItem] = this.formItem.searchPlanKeywordList
        return `已选${firstItem.keyword}...共${len}个关键词`
      }
      return '未添加关键词'
    },
    isReserve() {
      return this.formItem?.app_promotion_type === 'RESERVE'
    },
    convertData() {
      if (this.isReserve) return this.reserveConvertData
      return this.appDownloadConvertData
    },
    showLdy() {
      // 预约下载时显示落地页
      if (this.isReserve) return true
      return [1, 3].includes(this.formItem.ch_platform_id)
    },
    copyPage() {
      return this.$route.query.t === 'copy'
    },
    /**
     * @description: 根据当前选中的抖音达人，显示对应的视频
     */
    filteredAwemeVideoList() {
      if (!this.idea.aweme_video_user_id) return []
      return this.idea.authedAwemeVideoList.filter((item) => item.aweme_id === this.idea.aweme_video_user_id)
    },
    normalCreativeModeDisabled() {
      return !!this.formItem.star_task?.star_task_id
    },
    isSearch() {
      const { ad_type } = this.formItem
      return ad_type === 'SEARCH'
    },
    isDuration() {
      return this.isSearch && this.formItem.delivery_type === 'DURATION'
    },
    isNormal() {
      return this.isSearch && this.formItem.delivery_type === 'NORMAL'
    },
    isBlueFlowEnable() {
      const { blue_flow_package } = this.formItem
      return this.isNormal && blue_flow_package.blue_flow_package_setting === 'ON'
    },

    projectBidVisible() {
      const { delivery_mode, ad_type, delivery_setting } = this.formItem
      const { bid_type } = delivery_setting
      if (this.isSearch) {
        // 搜索广告：极速智投可设置项目出价
        if (this.isDuration) return true
        // 搜索广告：常规投放稳定成本可设置项目出价
        return this.isNormal && bid_type === 'CUSTOM'
      }
      return delivery_mode === 'PROCEDURAL' && bid_type === 'CUSTOM'
    },
    autoExtendTrafficDisabled() {
      return this.isDuration || this.isBlueFlowEnable
    },

    showFormFields() {
      return {
        // 智能拓流
        auto_extend_traffic: this.isSearch,
        // 动态创意
        dynamic_creative: this.isSearch && !this.isDuration,
        // 品牌名称
        brand_info: !this.isDuration,
        // 广告类别
        brand_category: !this.isDuration,
        // 广告评论
        comment: !this.isDuration,
        // 行动号召
        action_buttons: !this.isDuration,
        // 产品相关信息
        selling_points: !this.isDuration,
        // 原生锚点
        anchor_related_type: !this.isDuration,
        // 文本摘要
        text_abstract: this.isSearch,
        // 关键词
        keywords: this.isSearch
      }
    },
    blueFlowPackageKeywords() {
      const blueFlowPackageList = this.taskData[this.current]?.blueFlowPackageList || []
      const { blue_flow_package_id } = this.formItem.blue_flow_package || {}

      if (blue_flow_package_id) {
        const blueFlowPackage = blueFlowPackageList.find((i) => i.blue_flow_package_id === blue_flow_package_id)
        return blueFlowPackage?.blue_flow_keyword || []
      }

      return []
    }
  },
  watch: {
    isDouyin(nVal) {
      if (nVal) {
        // 抖音
        this.idea.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO'
        this.idea.imageCreative = []
        this.idea.largeCreative = []
        this.idea.image_list = this.idea.image_list.filter(
          (im) => !['CREATIVE_IMAGE_MODE_LARGE', 'CREATIVE_IMAGE_MODE_SMALL', 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'].includes(im.image_mode)
        )
      } else {
        // 非抖音
      }
    }
  },
  data() {
    const ids = isArray(getSession('taskIds')) ? getSession('taskIds') : []
    const copyData = isArray(getSession('taskRows')) ? getSession('taskRows') : []
    return {
      taskTargetingParams: {},
      carouselModal: false, // 图文创意选择弹窗model
      carouselList: [], // 图文创意详情
      carouselMultipleLimit: 0,
      carouselReplaceIndex: 0,

      pageModal: false,
      pageModalIndex: 0,
      showSearchBidKeywordModal: false,
      showPlanSearchKeywordModal: false,
      loaded: false,
      current: 0,
      taskIds: ids,
      dataGames: [], // 草花游戏下拉数据源
      accountData: [],
      wordIds: [], // 创意词
      audienceList: [], // 人群包数据
      mediaAudienceList: [], // 媒体包数据
      awemeList: [], // 抖音号列表
      copyTaskData: copyData, // 复制任务数据
      taskData: [], // 任务数据
      taskRawData: [],
      confirmBox: false,
      curDelTaskIndex: ''
    }
  },
  methods: {
    onTextAbstractEnterKeyConfirm() {
      const { text_abstract, text_abstract_list } = this.idea
      if (!text_abstract.trim()) return
      if (text_abstract_list.length >= 10) return
      const newlist = getSplitText(text_abstract, text_abstract_list)

      this.idea.text_abstract_list = text_abstract_list.concat(newlist).slice(0, 10)
      this.idea.text_abstract = ''
    },
    onBlueFlowPackageChange(row) {
      this.idea.blue_flow_keywords = ''
    },
    showCarouselSelectModal(itemLimit, index) {
      // 控制单选或多选
      this.carouselMultipleLimit = itemLimit
      this.carouselReplaceIndex = index
      this.carouselModal = true
    },
    onCarouselItemRemove(index) {
      this.carouselList.splice(index, 1)
      this.updateCreativeForm()
    },
    updateCreativeForm() {
      this.$set(
        this.idea,
        'carousel_material_list',
        this.carouselList.map((c) => ({ carousel_id: c.id }))
      )
    },
    // 选择图文创意
    onCarouselConfirm(list) {
      if (this.carouselMultipleLimit === 1) {
        // 修改
        const [item] = list
        if (this.carouselList.some((c) => c.id === item.id)) return
        this.carouselList.splice(this.carouselReplaceIndex, 1, item)
      } else {
        // 新增
        const newItems = list.filter((c) => !this.carouselList.some((c2) => c2.id === c.id))
        this.carouselList = this.carouselList.concat(newItems)
      }

      this.updateCreativeForm()
    },
    getCasouselList(carousel_material_list) {
      // 如果有图文创意，根据图文id获取图文素材详情
      if (carousel_material_list?.length) {
        getCarouselsById({
          ad_account_id: this.formItem.account,
          carousels: carousel_material_list.map((c) => c.carousel_id).join(',')
        }).then((carouselList) => {
          if (carouselList?.length) {
            this.carouselList = carouselList
          }
        })
      }
    },
    onExploreUpgradeChange(v) {
      if (v === 'EXPLORE_UPGRADE') {
        this.formItem.delivery_setting.deep_bid_type = ''
      }
    },
    showLandingPage(index) {
      this.pageModalIndex = index
      this.pageModal = true
    },
    onPageSelected([page]) {
      this.idea.web_url_material_list[this.pageModalIndex] = page.row.url
      this.pageModal = false
    },
    onSearchKeywordAdd() {
      this.showSearchBidKeywordModal = true
    },
    onPlanSearchKeywordAdd() {
      this.showPlanSearchKeywordModal = true
    },
    onPlanKeywordSelectConfirm(list) {
      this.formItem.searchPlanKeywordList = list
      this.idea.keywords = list.map((item) => ({ word: item.keyword, match_type: item.patern.value }))
    },
    onSearchKeywordSelectConfirm(list) {
      // 用于再次打开回显
      this.formItem.searchBidKeywordList = list
      // 用于项目提交
      this.formItem.keywords = list.map((item) => ({ word: item.keyword, bid_type: 'FEED_TO_SEARCH', match_type: item.patern.value }))
    },
    handleClickTask(index) {
      const params = deepCopy(this.formItem)
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params), ...this.validIdea(), ...this.invalidExtand(this.idea)] // 表单验证

      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }
      this.setTasker(index)
    },
    async setTargetingForm() {
      const task = this.taskData[this.current]
      const targetingForm = this.taskTargetingParams[task.taskId]
      const targetingId = task.targetings.caohuaTargetingId
      // 如果已经通过原始定向参数获取到了定向表单，直接使用
      if (targetingForm) {
        this.$refs.toutiaoTargetingFormRef.setForm(targetingForm)
      } else {
        // 否则通过原始定向参数获取定向表单并保存
        const form = {
          ...rebuildTargetingForm(task),
          targetingId,
          account: task.accounts[0]
        }
        // 兼容处理老的头条2.0批量流程IOS版本号
        if (form.ios_osv === 'NONE') form.ios_osv = '0.0'
        this.taskTargetingParams[task.taskId] = form
        this.$refs.toutiaoTargetingFormRef.setForm(form)
      }
    },
    // 切换任务
    setTasker(index) {
      this.current = index
      this.loaded = false
      const task = this.taskData[index]

      // 获取每个任务的图文素材
      this.$nextTick(() => {
        this.getCasouselList(this.idea.carousel_material_list)
      })
      this.setTargetingForm()

      if (task._xhr) {
        this.loaded = true
        return
      }
      this.preTaskLoad(task)
    },
    onStarTaskChange(e) {
      if (e?.star_task_id) {
        this.getAuthedAwemeListByStarTaskId(e.star_task_id)
      } else {
        this.getNormalAuthedAwemeList()
      }
    },
    getNormalAuthedAwemeList() {
      getAuthedAwemeList({ ad_account_id: this.taskData[this.current].account }).then((data) => {
        this.taskData[this.current].idea.aweme_video_user_id = ''
        this.taskData[this.current].idea.authedAwemeVideoList = data
        // 去重后的达人列表，用于达人下拉列表
        const uniqueAuthedAwemeList = uniqueArray(data, 'aweme_id')
        this.taskData[this.current].idea.uniqueAuthedAwemeList = uniqueAuthedAwemeList
      })
    },
    async getAuthedAwemeListByStarTaskId(starTaskId) {
      const accountInfo = await getAccountById({ ad_account_id: this.taskData[this.current].account })
      getAuthedAwemeListByStarDeliveryTaskId({
        advertiserId: accountInfo.advertiserId,
        adAccount: accountInfo.adAccount,
        starTaskId
      }).then((data) => {
        const authAwemeList = data.map((i) => {
          return { auth_type: 'VIDEO_ITEM', aweme_id: i.aweme_id, aweme_name: i.aweme_id, video_info: { ...i, title: i.video_title } }
        })

        this.taskData[this.current].idea.authedAwemeVideoList = authAwemeList
        this.taskData[this.current].idea.aweme_video_user_id = ''

        // 去重后的达人列表，用于达人下拉列表
        const uniqueAuthedAwemeList = uniqueArray(authAwemeList, 'aweme_id')
        this.taskData[this.current].idea.uniqueAuthedAwemeList = uniqueAuthedAwemeList
      })
    },
    findPathById(tree, targetId) {
      const path = []

      function dfs(nodes, currentPath) {
        for (const node of nodes) {
          const newPath = [...currentPath, node.id]
          if (node.id === targetId) {
            path.push(...newPath)
            return true
          }
          if (node.children && node.children.length > 0) {
            if (dfs(node.children, newPath)) {
              return true
            }
          }
        }
        return false
      }

      dfs(tree, [])
      return path
    },
    // 根所账号重载
    async preTaskLoad(task) {
      try {
        this.$Spin.show()
        const accountInfo = await getAccountById({ ad_account_id: task.account })

        const params = { account: task.account }
        const { star_task_id } = task.inner_plan_params
        const { ad_type, delivery_type, blue_flow_package } = task.outer_plan_params
        const requestList = [
          // getFlowPackage(params),
          getCreativeWordIds(params),
          // getCustomAudience(params),
          iesAccountSearch({ ad_account_id: task.account }),
          getStarDeliveryTaskList({ advertiserId: accountInfo.advertiserId, adAccount: accountInfo.adAccount }),
          getBlueFlowPackageList({ ad_account_id: task.account }),
          getBrandCategoryInfo({ ad_account_id: task.account })
        ]

        // 是否关联星广联投的达人视频
        if (star_task_id) {
          requestList.push(
            getAuthedAwemeListByStarDeliveryTaskId({
              advertiserId: accountInfo.advertiserId,
              adAccount: accountInfo.adAccount,
              starTaskId: star_task_id
            })
          )
        } else {
          requestList.push(getAuthedAwemeList({ ad_account_id: task.account }))
        }

        const data = await Promise.all(requestList)
        if (isArray(data)) {
          // const [flowPackage, creativeWord, audienceData, awemeList, authAwemeList] = data
          let [creativeWord, awemeList, starTaskList, blueFlowPackageList, brandCategoryInfo, authAwemeList] = data

          const { brand_category_info, brand_info_data } = brandCategoryInfo
          const [category_id] = task.idea.brand_info?.yuntu_category_id || []
          if (category_id) {
            const paths = this.findPathById(brand_category_info, category_id)
            task.idea.brand_info.yuntu_category_id = paths
          }

          task.brandCategory = brand_category_info
          task.brandInfo = brand_info_data

          task.blueFlowPackageList = blueFlowPackageList

          task.starTaskList = starTaskList
          if (creativeWord && isArray(creativeWord.creative_word)) {
            this.wordIds = creativeWord.creative_word.filter((ret) => myWordIds.includes(ret.creative_word_id))
          }
          if (task.idea.creative_material_mode === 'STATIC_ASSEMBLE') {
            // 程序化创意
            task.idea.title_list = task.idea.title_list.map((met) => {
              if (met.creative_word_ids && met.creative_word_ids.length && !isNumber(met.creative_word_ids[0])) {
                met.creative_word_ids = met.creative_word_ids.map((meta) => meta.creative_word_id)
              }
              return {
                title: met.title,
                creative_word_ids: this.pushWordIds(this.wordIds, met.creative_word_ids, met.title)
              }
            })
          }
          if (awemeList && isArray(awemeList)) {
            this.awemeList = awemeList
          }

          if (star_task_id) {
            authAwemeList = authAwemeList.map((i) => {
              return { auth_type: 'VIDEO_ITEM', aweme_id: i.aweme_id, aweme_name: i.aweme_name, video_info: { ...i, title: i.video_title } }
            })
          }

          if (isArray(authAwemeList)) {
            task.idea.authedAwemeVideoList = authAwemeList

            // 去重后的达人列表，用于达人下拉列表
            const uniqueAuthedAwemeList = uniqueArray(authAwemeList, 'aweme_id')
            task.idea.uniqueAuthedAwemeList = uniqueAuthedAwemeList
            const { awemeIdentity, image_list, aweme_video_user_id } = task.idea
            // 复制任务时判断当前是否选中，有选中则不进行初始化，image_list属于首次进入页面初始化元素
            if (awemeIdentity === 'AWEME_VIDEO' && !task.idea.selectedAwemeVideos.length) {
              const aweme_video_ids = image_list.filter((i) => i.item_id).map((i) => i.item_id)
              task.idea.selectedAwemeVideos = authAwemeList.filter(
                (al) => aweme_video_ids.includes(al.video_info.item_id) && al.aweme_id === aweme_video_user_id
              )
              this.$set(task.idea, 'aweme_video_list', task.idea.selectedAwemeVideos)
            }
          }
          task._xhr = true
          timeout(0).then(() => {
            this.$Spin.hide()
            this.loaded = true
          })
        } else this.$Spin.hide()
      } catch (err) {
        console.log(err)
        this.$Message.error(err)
        this.$Spin.hide() // 加载完成
      }
    },
    async handleAccount(meta) {
      if (isEmpty(meta.id)) return
      this.$set(this.taskData[this.current], 'account', meta.id)
      this.$set(this.taskData[this.current], 'ad_account_id', meta.id)
      this.$set(this.formItem, 'account', meta.id)
      this.$set(this.formItem, 'accounts', [meta])
      this.preTaskLoad(Object.assign(this.taskData[this.current], { _xhr: true, account: meta.id, accounts: [meta] })) // 更新账号相关
    },
    // 拼接优化目标名称
    getGoalName(external_action, deep_external_action) {
      let actionName = ''
      let deepActionName = ''

      if (external_action === 'AD_CONVERT_TYPE_ACTIVE') actionName = '激活'
      else if (external_action === 'AD_CONVERT_TYPE_PAY') actionName = '付费'
      else if (external_action === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') actionName = '注册'
      else if (external_action === 'AD_CONVERT_TYPE_GAME_ADDICTION') actionName = '关键行为'

      if (deep_external_action === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') deepActionName = '，深度转化，注册'
      else if (deep_external_action === 'AD_CONVERT_TYPE_PAY') deepActionName = '，深度转化，付费'
      else if (deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI') deepActionName = '，深度转化，付费ROI'
      else if (deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI_7D') return '，深度转化，付费ROI-7日'
      else if (deep_external_action === 'AD_CONVERT_TYPE_NEXT_DAY_OPEN') deepActionName = '，深度转化，次留'
      else deepActionName = '，深度转化，无'
      // else deepActionName = ''

      return actionName + deepActionName
    },
    getConvertId(external_action, deep_external_action, app_promotion_type) {
      if (JSON.stringify(deep_external_action) === '{}' || !deep_external_action) deep_external_action = ''

      const convertData = app_promotion_type === 'RESERVE' ? this.reserveConvertData : this.convertData
      const convertItem = convertData.filter(
        (ret) => ret.external_action === external_action && ret.deep_external_action === deep_external_action
      )
      if (convertItem.length) return convertItem.pop().key
      else this.$Message.error('事件管理转化获取格式错误')
    },
    getData() {
      this.$Spin.show()
      // 获取详情
      Promise.all([adAccount({ mediaId: this.media, authFlag: 1 }), getCaoHuaGames(), findPlanTaskById({ taskIds: this.taskIds })])
        .then((data) => {
          const [accountData, gameData, taskData] = data
          isArray(accountData) && (this.accountData = accountData)
          isArray(gameData) && (this.dataGames = gameData)
          if (isArray(taskData)) {
            const paternList = [
              { label: '广泛', value: 'EXTENSIVE' },
              { label: '短语', value: 'PHRASE' },
              { label: '精确', value: 'PRECISION' }
            ]
            const taskList = taskData.map((ret, tIndex) => {
              const formItem = Object.assign({ createType: 'new' }, ret.inner_plan_params, ret.outer_plan_params)
              const startTime = formatDate(new Date(ret.outer_plan_params.delivery_setting.start_time), 'yyyy-MM-dd')
              const endTime = formatDate(new Date(ret.outer_plan_params.delivery_setting.end_time), 'yyyy-MM-dd')
              const { schedule_time } = ret.outer_plan_params.delivery_setting

              // 使用原项目提交时，需要显示的项目名称
              formItem.project_name = ret.campaign_params.project_name
              // 使用原项目提交时，项目名称里有动态词时处理，保存由任务列表传过来的项目名称
              formItem.campaignRawName = this.copyTaskData[tIndex]?.campaignName

              this.reverWeektime(schedule_time)
              ret.account = ret.ad_account_id
              ret.accounts = [{ id: ret.ad_account_id, name: ret.ad_account_name }]

              if (ret.inner_plan_params.star_task_id) {
                formItem.star_task = { star_task_id: ret.inner_plan_params.star_task_id }
              }

              // 搜索快投
              const { keywords, search_bid_ratio, audience_extend, ad_type, delivery_type, blue_flow_package } = ret.outer_plan_params

              if (typeof search_bid_ratio !== 'undefined' || typeof audience_extend !== 'undefined') {
                formItem.keywordSwitch = 1
              } else {
                formItem.keywordSwitch = 0
              }

              if (!blue_flow_package) {
                formItem.blue_flow_package = {
                  blue_flow_package_id: '',
                  blue_flow_package_setting: 'OFF'
                }
              } else {
                formItem.blue_flow_package = blue_flow_package
              }

              // 设置回显字段
              if (keywords?.length) {
                formItem.searchBidKeywordList = keywords.map((item) => {
                  const patern = paternList.find((patern) => patern.value === item.match_type)
                  return {
                    keyword: item.word,
                    patern: { ...patern }
                  }
                })
              } else {
                formItem.searchBidKeywordList = []
              }

              if (ret.creative_params.keywords?.length) {
                formItem.searchPlanKeywordList = ret.creative_params.keywords.map((item) => {
                  const patern = paternList.find((patern) => patern.value === item.match_type)
                  return {
                    keyword: item.word,
                    patern: { ...patern }
                  }
                })
              } else {
                formItem.searchPlanKeywordList = []
              }

              const { external_action, deep_external_action, app_promotion_type, delivery_setting } = ret.outer_plan_params

              const bidTypeInfo = {
                bid_type: delivery_setting.bid_type,
                bid_type_upgrade: 'CUSTOM'
              }
              // 竞价策略：广告潜力探索处理
              if (delivery_setting.bid_type === 'EXPLORE_UPGRADE') {
                bidTypeInfo.bid_type = 'CUSTOM'
                bidTypeInfo.bid_type_upgrade = 'EXPLORE_UPGRADE'
              }

              // 非批量复制 === 批量失败修改
              if (!this.copyPage) {
                // 头条2.0项目是否可以修改
                // 1、是项目广告（项目名称 = 广告名称）
                // 2、步骤标记 < 3
                if (ret.task_progress < 3 && formItem.plan_name === formItem.project_name) {
                  formItem.createType = 'new'
                } else {
                  formItem.createType = 'inherit'
                }
              }

              ret.formItem = Object.assign({}, formItem, {
                delivery_mode: formItem.delivery_mode || 'MANUAL', // 为前期没有传值添加默认值
                delivery_setting: {
                  // 设置投放速度默认值
                  bid_speed: 'FAST',
                  // 设置预算择优分配(CBO)默认值
                  budget_optimize_switch: 'OFF',
                  ...formItem.delivery_setting,
                  ...bidTypeInfo
                },
                // targetingName: ret.targetings.targetingName,
                account: ret.account,
                ad_account_name: ret.ad_account_name,
                plan_name: this.copyState ? `${formItem.plan_name}_复制` : formItem.plan_name,
                convert_name: this.getGoalName(external_action, deep_external_action),
                convertId: this.getConvertId(external_action, deep_external_action, app_promotion_type),
                media_pack_switch: formItem.media_pack_switch,
                datetime: [startTime, endTime],
                weektimeData: deepCopy(weektimeData)
              })

              let web_url_material_list = ret.creative_params.web_url_material_list || []

              // 获取预约投放落地页
              if (ret.outer_plan_params.app_promotion_type === 'RESERVE') {
                web_url_material_list = ret.creative_params.external_url_material_list || []
              }

              const { product_info, keywords: planKeywords, dynamic_creative_switch } = ret.creative_params

              let blue_flow_keywords = ''

              // 蓝海流量的关键词只有一个，取第一个词
              if (ad_type === 'SEARCH' && delivery_type === 'NORMAL' && blue_flow_package?.blue_flow_package_setting === 'ON') {
                blue_flow_keywords = planKeywords[0].word
              }

              const brand_info = {}
              if (ret.creative_params.brand_info) {
                const { cdp_brand_id, yuntu_category_id } = ret.creative_params.brand_info
                if (cdp_brand_id) {
                  brand_info.cdp_brand_id = cdp_brand_id
                }
                if (yuntu_category_id) {
                  brand_info.yuntu_category_id = [String(yuntu_category_id)]
                }
              }

              if (dynamic_creative_switch === 'ON') {
              } else {
                ret.dynamic_creative_switch = 'OFF'
                ret.advanced_dc_settings = ['OPTIMIZE_SEARCH_RESULTS_PAGE', 'OPTIMIZE_LANDING_PAGE']
              }

              ret.creative_params = Object.assign({}, ret.creative_params, {
                creative_mode: ret.creative_params.creative_mode,
                image_ids: product_info ? String(product_info.image_ids[0]) : '',
                selling_points: product_info ? product_info.selling_points : [],
                app_name: product_info ? product_info.titles[0] : '',
                awemeIdentity: ret.creative_params.awemeIdentity,
                anchor_id: ret.creative_params.anchor_material_list ? ret.creative_params.anchor_material_list[0].anchor_id : '',
                anchor_related_type: ret.creative_params.native_setting ? ret.creative_params.native_setting.anchor_related_type : 'OFF',
                aweme_id: ret.creative_params.native_setting ? ret.creative_params.native_setting.aweme_id : '',
                aweme_video_user_id: ret.creative_params.native_setting ? ret.creative_params.native_setting.aweme_id : '',
                is_feed_and_fav_see: ret.creative_params.native_setting ? ret.creative_params.native_setting.is_feed_and_fav_see : 'ON',
                web_url_material_list,
                text_abstract_list: ret.creative_params.text_abstract_list
                  ? ret.creative_params.text_abstract_list.map((i) => i.abstract_text)
                  : [],
                blue_flow_keywords,
                brand_info
              })

              ret.idea = Object.assign({}, defaultIdeaParams, ret.creative_params)

              // 处理随机出价等参数
              this.handleRandomBid(ret)

              return ret
            })
            this.taskRawData = deepCopy(taskList)
            this.taskData = taskList
            timeout(0).then(() => {
              this.setTasker(0)
            }) // 自动切到第一任务
          } else this.$Spin.hide() // 加载完成
        })
        .catch((err) => {
          console.log(err)
          err && this.$Message.error(err.message)
        })
    },
    handleSubmit() {
      const params = deepCopy(this.formItem)
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params), ...this.validIdea(), ...this.invalidExtand(this.idea)] // 表单验证
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      if (this.taskData.some((ret) => !ret._xhr)) {
        this.$Message.error('请切换任务编号，首次加载数据成功方可复制， Code: 20001')
        return
      }

      const taskData = deepCopy(this.taskData).map((ret, _index) => {
        const targetings = this.taskTargetingParams[ret.taskId]
        const { inventory_type, inventory_catalog, union_video_type } = targetings
        const { ad_type, delivery_type, blue_flow_package } = ret.formItem

        const isStarTaskAutoMaterialEnable =
          ret.formItem.star_task?.star_task_id && ret.formItem.star_auto_material_addition_switch === 'ON'

        // creative_params
        const {
          image_ids,
          selling_points,
          app_name,
          awemeIdentity,
          aweme_id,
          is_feed_and_fav_see,
          anchor_related_type,
          anchor_id,
          anchor_name,
          web_url_material_list,
          aweme_video_list,
          aweme_video_user_id
        } = ret.idea

        ret.idea = Object.assign(ret.idea, {
          image_list: ret.idea.creatives,
          title_list: ret.idea.title_list.map((met) => {
            return {
              title: met.title,
              creative_word_ids: met.creative_word_ids.map((meta) => meta.creative_word_id)
            }
          }),
          creatives: [],
          product_info: {
            titles: [app_name],
            image_ids: [image_ids],
            selling_points
          }
        })

        // 星广联投开启自动优选素材，清空文案
        if (isStarTaskAutoMaterialEnable) {
          ret.idea.title_list = undefined
        }

        if (ad_type === 'SEARCH') {
          if (ret.idea.text_abstract_list?.length) {
            ret.idea.text_abstract_list = ret.idea.text_abstract_list.map((i) => {
              return {
                abstract_text: i
              }
            })
          }

          if (delivery_type === 'NORMAL') {
            // 开启了蓝海流量，使用蓝海流量的关键词
            if (blue_flow_package.blue_flow_package_setting === 'ON') {
              ret.idea.keywords = [
                {
                  word: ret.idea.blue_flow_keywords,
                  match_type: 'EXTENSIVE'
                }
              ]
            }
          } else {
            // 非搜索广告常规投放不需要蓝海流量
            ret.formItem.blue_flow_package = undefined
          }
        } else {
          // 非搜索广告不需要蓝海流量
          ret.formItem.blue_flow_package = undefined
        }

        // 原生广告
        if (awemeIdentity === 'AWEME') {
          ret.idea = Object.assign(ret.idea, {
            native_setting: {
              aweme_id,
              is_feed_and_fav_see,
              anchor_related_type
            }
          })
          if (anchor_related_type === 'SELECT') {
            ret.idea = Object.assign(ret.idea, {
              anchor_material_list: [
                {
                  anchor_type: 'APP_GAME',
                  anchor_id
                }
              ],
              anchor_name
            })
          } else if (ret.idea.anchor_material_list) delete ret.idea.anchor_material_list
        } else if (awemeIdentity === 'AWEME_VIDEO' && aweme_video_list?.length) {
          if (isStarTaskAutoMaterialEnable) {
            ret.idea = Object.assign(ret.idea, {
              native_setting: {
                aweme_setting_type: ret.idea.aweme_setting_type,
                anchor_related_type
              }
            })
          } else {
            ret.idea = Object.assign(ret.idea, {
              native_setting: {
                aweme_id: aweme_video_user_id,
                anchor_related_type
              }
            })
          }

          if (anchor_related_type === 'SELECT') {
            ret.idea = Object.assign(ret.idea, {
              anchor_material_list: [
                {
                  anchor_type: 'APP_GAME',
                  anchor_id
                }
              ],
              anchor_name
            })
          } else if (ret.idea.anchor_material_list) delete ret.idea.anchor_material_list
          const videolist = aweme_video_list.map((ret) => {
            return {
              item_id: ret.video_info.item_id,
              video_id: ret.video_info.video_id,
              video_cover_id: ret.video_info.video_cover_id,
              image_mode: ret.video_info.image_mode,
              auth_type: 'VIDEO_ITEM'
            }
          })
          ret.idea.image_list.splice(0, ret.idea.image_list.length) // 先清空掉之前的选择的常规创意
          ret.idea.image_list.push(...videolist)
        } else {
          ret.idea.native_setting && delete ret.idea.native_setting
          ret.idea.anchor_material_list && delete ret.idea.anchor_material_list
        }
        const hasLogo = ret.idea.creatives.some((i) => i.image_mode === 'PRODUCT_LOGO')
        if (!hasLogo) {
          ret.idea.image_list.push({
            image_mode: 'PRODUCT_LOGO',
            image_ids: [image_ids]
          })
        }
        // ret.idea.aweme_id && delete ret.idea.aweme_id
        // ret.idea.is_feed_and_fav_see && delete ret.idea.is_feed_and_fav_see
        // ret.idea.anchor_related_type && delete ret.idea.anchor_related_type
        // ret.idea.anchor_id && delete ret.idea.anchor_id
        // ret.idea.anchor_name && delete ret.idea.anchor_name
        // ret.idea.awemeIdentity && delete ret.idea.awemeIdentity
        // outer_plan_params
        ret.formItem = Object.assign(ret.formItem, {
          delivery_range: {
            inventory_type,
            inventory_catalog,
            union_video_type
          }
        })
        // if (inventory_type.includes('INVENTORY_HOTSOON_FEED') && ret.inner_plan_params.ch_platform_id === 2 && isArray(ret.formItem.delivery_range.inventory_type)) ret.formItem.delivery_range.inventory_type = ret.formItem.delivery_range.inventory_type.filter(ret => ret !== 'INVENTORY_HOTSOON_FEED')

        if (ret.inner_plan_params.ch_platform_id === 2 && ret.inner_plan_params.media_pack_switch) {
          delete ret.inner_plan_params.media_pack_switch
        }

        if (ret.formItem.star_task?.star_task_id) {
          ret.inner_plan_params.star_task_id = ret.formItem.star_task.star_task_id
        }

        // 深度参数清理
        if (ret.formItem.delivery_setting.deep_bid_type === 'DEEP_BID_MIN') {
          delete ret.idea.roi_goal
          delete ret.formItem.delivery_setting.roi_goal
        } else if (
          ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(ret.formItem.delivery_setting.deep_bid_type)
        ) {
          delete ret.idea.deep_cpabid
        } else if (ret.formItem.delivery_setting.deep_bid_type === 'BID_PER_ACTION') {
          delete ret.idea.roi_goal
          delete ret.idea.deep_cpabid
          delete ret.formItem.delivery_setting.roi_goal
          delete ret.formItem.delivery_setting.deep_cpabid
        } else {
          delete ret.formItem.delivery_setting.deep_bid_type
          delete ret.idea.roi_goal
          delete ret.idea.deep_cpabid
          delete ret.formItem.delivery_setting.roi_goal
          delete ret.formItem.delivery_setting.deep_cpabid
        }

        if (ret.formItem.delivery_setting.bid_type === 'NO_BID') {
          delete ret.idea.cpa_bid
          delete ret.idea.roi_goal
          delete ret.idea.deep_cpabid

          delete ret.formItem.delivery_setting.cpa_bid
          delete ret.formItem.delivery_setting.roi_goal
          delete ret.formItem.delivery_setting.deep_cpabid
        }
        const creative_params = deepCopy(ret.idea)
        const outer_plan_params = deepCopy(ret.formItem)

        // 预约投放落地页参数修改
        if (ret.outer_plan_params.app_promotion_type === 'RESERVE') {
          creative_params.external_url_material_list = web_url_material_list
          delete creative_params.web_url_material_list
          delete outer_plan_params.asset_ids
        }

        if (outer_plan_params.delivery_range === 'DEFAULT' && outer_plan_params.union_video_type) delete outer_plan_params.union_video_type

        if (outer_plan_params.delivery_mode === 'PROCEDURAL') {
          outer_plan_params.delivery_range = {
            inventory_catalog: 'UNIVERSAL_SMART',
            inventory_type: ['INVENTORY_UNIVERSAL']
          }
        } else {
          delete outer_plan_params.delivery_setting.cpa_bid
          delete outer_plan_params.delivery_setting.roi_goal
          delete outer_plan_params.delivery_setting.deep_cpabid
        }

        // 对于选择自定义媒体定向流量包，该字段不传
        if (outer_plan_params.superior_popularity_type && outer_plan_params.superior_popularity_type === 'CUSTOM') {
          delete outer_plan_params.superior_popularity_type
        }

        // 事件管理参数
        if (outer_plan_params.convertId) {
          outer_plan_params.external_action = this.convertData
            .filter((ret) => ret.key === outer_plan_params.convertId)
            .pop().external_action
          outer_plan_params.deep_external_action = this.convertData
            .filter((ret) => ret.key === outer_plan_params.convertId)
            .pop().deep_external_action
          delete outer_plan_params.convertId
        }

        const { delivery_setting } = outer_plan_params
        const { bid_type, budget_mode, bid_type_upgrade } = delivery_setting

        // 如果预算不限，删除budget
        if (budget_mode === 'BUDGET_MODE_INFINITE') {
          delete outer_plan_params.delivery_setting.budget
        }

        // 如果竞价策略不是稳定成本，删除投放速度字段
        if (bid_type !== 'CUSTOM') {
          delete outer_plan_params.delivery_setting.bid_speed
        }
        // 广告潜力探索处理
        if (bid_type === 'CUSTOM') {
          outer_plan_params.delivery_setting.bid_type = bid_type_upgrade
          delete outer_plan_params.delivery_setting.bid_type_upgrade
        }

        // 如果竞价策略不是最大转化，删除预算择优分配(CBO)字段
        if (bid_type !== 'NO_BID') {
          delete outer_plan_params.delivery_setting.budget_optimize_switch
        }

        // 开启预算择优分配(CBO)时，提交时广告预算传0
        const { budget_optimize_switch } = outer_plan_params.delivery_setting
        if (bid_type === 'NO_BID' && budget_optimize_switch === 'ON') {
          creative_params.budget = 0
        }

        // 自动投放时删除出价参数
        if (outer_plan_params.delivery_mode === 'PROCEDURAL') {
          'budget' in creative_params && delete creative_params.budget
          delete creative_params.cpa_bid
          delete creative_params.roi_goal
          delete creative_params.deep_cpabid
        }

        const { keywordSwitch } = ret.formItem
        // 是否开启搜索快投 自动投放 删除
        if (outer_plan_params.delivery_mode === 'PROCEDURAL' || !keywordSwitch) {
          delete outer_plan_params.searchBidKeywordList
          delete outer_plan_params.search_bid_ratio
          delete outer_plan_params.keywords
          delete outer_plan_params.audience_extend
          delete outer_plan_params.keywordSwitch
        } else {
          const { search_bid_ratio } = outer_plan_params
          if (!search_bid_ratio) {
            delete outer_plan_params.search_bid_ratio
          }
        }

        // 通投和搜索广告（非极速）添加品牌名称和广告类别
        if (delivery_type !== 'DURATION') {
          if (creative_params.brand_info) {
            const yuntu_category_id = creative_params.brand_info.yuntu_category_id
            if (isArray(yuntu_category_id)) {
              creative_params.brand_info.yuntu_category_id = Number(yuntu_category_id.slice(-1))
            }
          }
        }

        if (creative_params.dynamic_creative_switch === 'OFF') {
          creative_params.advanced_dc_settings = undefined
        }

        // 极速智投的创意参数
        const durationCreativeParams = {}

        if (outer_plan_params.ad_type === 'SEARCH') {
          outer_plan_params.delivery_range = {
            inventory_catalog: 'MANUAL',
            inventory_type: ['INVENTORY_SEARCH']
          }

          if (delivery_type === 'NORMAL' && outer_plan_params.blue_flow_package.blue_flow_package_setting === 'ON') {
            // todo
          } else {
            outer_plan_params.blue_flow_package = undefined
          }

          if (delivery_type === 'NORMAL' && ret.formItem.delivery_setting.bid_type !== 'NO_BID') {
            outer_plan_params.delivery_setting.cpa_bid = ret.formItem.delivery_setting.cpa_bid
          }
          if (delivery_type === 'NORMAL' && creative_params.dynamic_creative_switch === 'OFF') {
            creative_params.advanced_dc_settings = undefined
          }

          if (delivery_type === 'DURATION') {
            outer_plan_params.delivery_setting.cpa_bid = ret.formItem.delivery_setting.cpa_bid

            durationCreativeParams.creative_display_mode = creative_params.creative_display_mode
            durationCreativeParams.creative_material_mode = creative_params.creative_material_mode

            durationCreativeParams.text_abstract_list = creative_params.text_abstract_list
            // durationCreativeParams.auto_extend_traffic = creative_params.auto_extend_traffic
            durationCreativeParams.awemeIdentity = creative_params.awemeIdentity
            durationCreativeParams.creative_mode = creative_params.creative_mode
            // 极速智投不需要logo
            durationCreativeParams.image_list = creative_params.image_list
            // durationCreativeParams.keywords = creative_params.keywords
            durationCreativeParams.native_setting = creative_params.native_setting
            durationCreativeParams.product_info = creative_params.product_info
            durationCreativeParams.creatives_detail = creative_params.creatives_detail
            durationCreativeParams.imageCreative = creative_params.imageCreative
            durationCreativeParams.largeCreative = creative_params.largeCreative
            durationCreativeParams.videoCreative = creative_params.videoCreative
            durationCreativeParams.title_list = creative_params.title_list
            durationCreativeParams.operation = creative_params.operation

            if (creative_params.carousel_material_list?.length > 0) {
              durationCreativeParams.carousel_material_list = creative_params.carousel_material_list
            }

            if (creative_params.web_url_material_list?.length > 0) {
              durationCreativeParams.web_url_material_list = creative_params.web_url_material_list
            }
          }
          delete creative_params.cpa_bid
          delete creative_params.roi_goal
          delete creative_params.deep_cpabid
        }

        ret.campaign_params = {
          project_name: ret.formItem.plan_name
        }
        // 批量复制时，删除批量新增时添加的creative_name
        delete creative_params.creative_name

        let targetingParam = {}
        const submitParams = getSubmitTargetingParams(targetings)

        if (outer_plan_params.ad_type === 'ALL') {
          // 选取自动投放支持的定向参数、并清除人群定向参数
          const proceduralTargetingsParams = pick(clone(submitParams), proceduralTargetings)
          if (proceduralTargetingsParams.audiences?.retargeting_tags_include) {
            proceduralTargetingsParams.audiences.retargeting_tags_include = []
          }

          targetingParam = outer_plan_params.delivery_mode === 'PROCEDURAL' ? proceduralTargetingsParams : submitParams
        }

        if (outer_plan_params.ad_type === 'SEARCH') {
          // 选取搜索广告支持的定向参数
          const searchAdTargetingsParams = pick(clone(submitParams), searchAdTargetings)
          // 搜索广告极速智投去掉设备品牌定向
          const { device_brand, ...durationTargetingParams } = searchAdTargetingsParams
          targetingParam = outer_plan_params.delivery_type === 'DURATION' ? durationTargetingParams : searchAdTargetingsParams
        }

        // 未开启星广联投自动素材优选，清空下列字段的值不提交
        if (!isStarTaskAutoMaterialEnable) {
          outer_plan_params.star_auto_material_addition_switch = undefined
          creative_params.original_video_title = undefined
        }

        const planData = {
          taskId: ret.taskId,
          campaign_params: ret.campaign_params,
          ad_account_id: ret.formItem.account,
          ad_account_name: ret.ad_account_name,
          batch_task_type: ret.batch_task_type,
          campaign_id: ret.formItem.campaign_id,
          convert_name: ret.convert_name,
          convert_params: ret.convert_params,
          creative_params:
            outer_plan_params.ad_type === 'SEARCH' && delivery_type === 'DURATION' ? durationCreativeParams : creative_params,
          inner_plan_params: Object.assign(ret.inner_plan_params, { plan_name: ret.formItem.plan_name }),
          operation: ret.operation,
          outer_plan_params: outer_plan_params,
          targetings: {
            targetingId: this.saveTargetingId,
            targetingName: ret.formItem.targetingName,
            targetingParam
          },
          task_progress: ret.task_progress,
          task_status: ret.task_status,
          _: Date.now()
        }

        // 使用原项目提交,taskRawData保存了项目的原始数据， 忽略定向 排期与出价 营销目标及场景 等模块的改动
        if (ret.formItem.createType === 'inherit') {
          const rawData = this.taskRawData[_index]

          // 使用原项目，预约投放删除asset_ids
          if (ret.outer_plan_params.app_promotion_type === 'RESERVE') {
            delete rawData.outer_plan_params.asset_ids
          }

          // 原项目提交时的投放账号不能修改
          planData.ad_account_id = rawData.ad_account_id

          // 原项目提交时的项目名称
          planData.campaign_params = {
            project_name: rawData.formItem.campaignRawName || rawData.campaign_params.project_name
          }
          planData.outer_plan_params = {
            ...rawData.outer_plan_params,
            plan_name: planData.inner_plan_params.plan_name
          }
          const { check, ...t } = rawData.targetings
          planData.targetings = t
          // planData.creative_params = {
          //   ...planData.creative_params,
          //   budget: rawData.creative_params.budget,
          //   cpa_bid: rawData.creative_params.cpa_bid,
          //   roi_goal: rawData.creative_params.roi_goal,
          //   deep_cpabid: rawData.creative_params.deep_cpabid
          // }
        }

        return planData
      })
      const callFn = (data) => {
        this.loading = false
        if (data) {
          rmSession('taskIds')
          this.$Message.info({
            content: '提交成功！，页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      }
      const err = (err) => {
        this.$Message.error(err)
      }
      // 提交
      this.loading = true
      if (this.copyState) {
        addToutiaoBatchTaskSecond({ planlist: taskData, copy_task_bool: Number(this.copyState), operation: 'enable' })
          .then(callFn)
          .catch(err)
      } else updatePlanTaskByIdNew({ planlist: taskData }).then(callFn).catch(err)
    },
    removeTask(index) {
      if (isArray(this.taskIds) && this.taskIds.length && isArray(this.taskData) && this.taskData.length) {
        if (index < this.current) {
          this.current--
          this.taskIds.splice(index, 1)
          this.taskData.splice(index, 1)
        } else if (index === this.current) {
          if (this.current === this.taskIds.length - 1) {
            this.handleClickTask(this.current - 1)
            this.taskIds.splice(index, 1)
            this.taskData.splice(index, 1)
          } else {
            this.taskIds.splice(index, 1)
            this.taskData.splice(index, 1)
            this.handleClickTask(this.current)
          }
        } else {
          this.taskIds.splice(index, 1)
          this.taskData.splice(index, 1)
        }
      }
    },
    showConfirmBox(e, index) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
        this.confirmBox = true
        this.curDelTaskIndex = index
      }
    },
    creativeModeChange() {
      if (this.idea.creative_mode === 1) {
        this.idea.awemeIdentity = 'ACCOUNT'
      } else if (this.idea.creative_mode === 2) {
        this.idea.awemeIdentity = 'AWEME_VIDEO'
      }
    },
    awemeSelect(aweme_id) {
      if (aweme_id) {
        const item = this.idea.uniqueAuthedAwemeList.find((v) => v.aweme_id === aweme_id)
        this.idea.selectedAwemeVideos = []
        this.idea.selectedAwemeVideos.push(item)
        this.$set(this.idea, 'aweme_video_list', this.idea.selectedAwemeVideos)
      }
    },
    onAwemeVideoSelect(item) {
      const { video_info } = item
      const selected = this.idea.selectedAwemeVideos.find((v) => v.video_info.item_id === video_info.item_id)
      if (selected) {
        this.idea.selectedAwemeVideos = this.idea.selectedAwemeVideos.filter((v) => v.video_info.item_id !== video_info.item_id)
      } else {
        this.idea.selectedAwemeVideos.push(item)
      }
      this.$set(this.idea, 'aweme_video_list', this.idea.selectedAwemeVideos)
    },
    onAwemeVideoPreview(item) {
      window.open(item.video_info.aweme_play_url, '_blank')
    },
    onTaskDuplicate(index) {
      const currTask = this.taskData[index]
      const newTask = deepCopy(currTask)
      const taskId = `复制任务${taskDupIndex++}`

      newTask.taskId = taskId
      newTask.formItem.plan_name += `_${taskId}`
      newTask._xhr = false // 更改任务为未加载状态

      this.taskData.push(newTask)
      this.taskIds.push(taskId)
      this.taskRawData = deepCopy(this.taskData)
    },
    handleRandomBid({ idea, formItem }) {
      // 处理项目层级目标出价、roi、深度目标出价的随机参数
      if (formItem && formItem?.delivery_setting) {
        const { bid_range, bid_num_range, deep_bid_range, deep_bid_num_range, roi_bid_range, roi_bid_num_range } =
          formItem.delivery_setting || {}
        if (bid_range === 1) {
          formItem.delivery_setting.cpa_bid = this.bidRandom(bid_num_range)
          delete formItem.delivery_setting.bid_range
          delete formItem.delivery_setting.bid_num_range
        }
        if (deep_bid_range === 1) {
          formItem.delivery_setting.deep_cpabid = this.bidRandom(deep_bid_num_range)
          delete formItem.delivery_setting.deep_bid_range
          delete formItem.delivery_setting.deep_bid_num_range
        }
        if (roi_bid_range === 1) {
          formItem.delivery_setting.roi_goal = this.bidRandom(roi_bid_num_range, 4)
          delete formItem.delivery_setting.roi_bid_range
          delete formItem.delivery_setting.roi_bid_num_range
        }
      }
      // 处理广告层级目标出价、roi、深度目标出价的随机参数
      if (idea) {
        const { bid_range, bid_num_range, deep_bid_range, deep_bid_num_range, roi_bid_range, roi_bid_num_range } = idea || {}
        if (bid_range === 1) {
          idea.cpa_bid = this.bidRandom(bid_num_range)
          delete idea.bid_range
          delete idea.bid_num_range
        }
        if (deep_bid_range === 1) {
          idea.deep_cpabid = this.bidRandom(deep_bid_num_range)
          delete idea.deep_bid_range
          delete idea.deep_bid_num_range
        }
        if (roi_bid_range === 1) {
          idea.roi_goal = this.bidRandom(roi_bid_num_range, 4)
          delete idea.roi_bid_range
          delete idea.roi_bid_num_range
        }
      }
    },
    bidRandom(range, scale = 2) {
      if (isArray(range) && range.length === 2) {
        const min = parseFloat(range[0])
        const max = parseFloat(range[1])
        return parseFloat((Math.random() * (max - min) + min).toFixed(scale))
      }
      return undefined
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.carousel-list {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  max-height: 420px;
  overflow: auto;
}
.layout-content {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;

  height: calc(100% - 64px);
}

.star-auto-material-switch {
  display: flex;
  align-items: center;
  margin-top: 6px;
  p {
    font-size: 12px;
    margin-left: 10px;
  }
}

.m-wrap-edit {
  position: relative;
  padding: 12px 15px 0 15px;

  .m-header-edit {
    overflow: auto;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 20px 48px;
    margin-bottom: 12px;
    background-color: #ffffff;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.04);
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .task-h2 {
      line-height: 30px;
      font-size: 22px;
      padding-right: 48px;
      min-width: 140px;
    }
  }

  .module-content {
    padding-bottom: 65px;
  }
}

.m-creative-btn {
  border-radius: 4px;
  border: solid 1px #efefef;
  position: relative;
  display: inline-block;
  line-height: 32px;
  padding: 0 12px;
  margin-right: 12px;
  cursor: pointer;

  .m-creat-btn {
    color: #2b85e4;
  }

  i.ivu-icon {
    position: absolute;
    top: -10px;
    right: -6px;

    &:before {
      position: relative;
      z-index: 2;
    }

    &:after {
      content: ' ';
      display: inline-block;
      width: 11px;
      height: 11px;
      border-radius: 6px;
      background-color: #fff;
      position: absolute;
      top: 3px;
      right: 2px;
      z-index: 1;
    }
  }
}

.m-current {
  color: #ffffff;
  border-color: #2b85e4;
  background-color: #2b85e4;
}

.ad-group,
.ad-submit {
  padding: 15px 0 0 0;

  .ad-group-moduler,
  .ad-submit-moduler {
    padding: 16px 24px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05);
  }
}

.ad-submit {
  padding-bottom: 0;
  position: sticky;
  bottom: 0;
  z-index: 999;

  .ad-submit-moduler {
    display: flex;
    justify-content: flex-end;
  }

  .ad-submit-control {
    text-align: right;

    button {
      margin-left: 6px !important;
    }
  }
}

.disable-out-plan {
  position: relative;
  z-index: 1;

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }
}

.nav-left {
  background: #fff;
  box-shadow: 0px 2px 4px 0px #eff1fa;
  padding: 22px 15px;
}

/* 表单选项 */
::v-deep .row-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 32px;

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }
}

::v-deep .ivu-poptip-rel {
  width: inherit;
}

/* 单选框覆盖 */
::v-deep .ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

::v-deep .ivu-checkbox-wrapper {
  .ivu-checkbox {
    margin-right: 10px;
  }
}

::v-deep .ivu-tabs-mini {
  .ivu-tabs-bar {
    margin-bottom: 0;
  }

  .ivu-tabs-tab {
    padding: 8px;
  }
}

::v-deep .m-tooltip-content {
  z-index: 1025;

  img,
  video {
    max-width: 220px;
    max-height: 156px;
  }
}

/* 上传进度条 */
::v-deep .ivu-upload-list {
  margin: 0;
}

::v-deep .ivu-table .ivu-table-header {
  background-color: #f8f8f9;
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }
}

.item-field {
  height: 32px;
  line-height: 32px;
}

.row-item-control {
  margin-top: 12px;
}

.row-item-label {
  text-align: right;
  padding: 8px;
}

.m-creat-box {
  min-height: 165px;
}

.m-download {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  height: 32px;
  line-height: 32px;
}

.c-idea {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    height: calc(100% - 96px);
  }

  .c-idea-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;
    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.c-idea-bar {
  position: relative;
  flex: auto;
  padding: 15px 24px 15px 48px;
  background-color: #ffffff;

  .c-bar-content {
    height: inherit;

    .m-creative-btn {
      border-radius: 4px;
      border: solid 1px #efefef;
      position: relative;
      display: inline-block;
      line-height: 32px;
      padding: 0 12px;
      margin-right: 12px;

      .m-creat-btn {
        color: #2b85e4;
      }

      .m-remove {
        position: absolute;
        cursor: pointer;
        color: #fff;
        width: 11px;
        height: 11px;
        line-height: 11px;
        font-size: 60%;
        border-radius: 9px;
        background-color: #ff635c;
        text-align: center;
        display: block;
        z-index: 11;
        top: -6px;
        right: -3px;
        transition: display 0.2s ease-in-out;
      }
    }

    .m-current {
      color: #ffffff;
      border-color: #2b85e4;
      background-color: #2b85e4;
    }
  }
}

::v-deep .ivu-btn {
  margin-right: 8px;
}

.aweme-video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 300px;
  max-height: 420px;
  overflow-y: auto;

  .aweme-video-item {
    border: 2px solid transparent;
    border-radius: 2px;
    position: relative;
    height: 293px;
    overflow: hidden;

    &.active {
      border: 2px solid #1974ff;

      .check-icon {
        color: #1974ff;
        font-weight: 700;
      }
    }

    .preview {
      position: absolute;
      left: 10px;
      top: 10px;
      z-index: 1;
      cursor: pointer;
    }

    .check-icon {
      color: transparent;
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 20px;
      z-index: 1;
    }

    .desc {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 1;
      line-height: 14px;
      font-size: 12px;
      color: #fff;
      padding: 5px;
      background: rgba(0, 0, 0, 0.5);
    }

    .aweme-video-cover {
      cursor: pointer;
    }
  }
}
</style>
